import { useState } from "react";
import api from "../../../../lib/api";
import { SectionCard, MiniStat } from "../shared";
import CatalogRulesEditor from "./CatalogRulesEditor";
import { toast } from "sonner";
import { Package, RefreshCw, ExternalLink } from "lucide-react";


export default function CatalogMirrorPerBuyerSection({ buyer, productsCount, lastSync }) {
  const [collapseSignal, setCollapseSignal] = useState(0);
  if (!buyer) return null;
  return (
    <SectionCard
      icon={Package}
      title="Step 3 · Catalog mirror"
      subtitle={`${buyer.company || buyer.name} — which SKUs are exposed to this buyer. Manage exclusions and force a resync when needed.`}
      testId="setup-section-catalog-mirror-per-buyer"
      defaultOpen={false}
      forceCollapseSignal={collapseSignal}
      right={
        <a href="/seller/catalog" className="text-[11.5px] mono uppercase tracking-[0.14em] rounded-full h-8 px-3 border border-border hover:bg-secondary/50 inline-flex items-center gap-1.5">
          <ExternalLink className="w-3 h-3"/> Open Catalog app
        </a>
      }
    >
      <div className="grid grid-cols-3 gap-4 p-5">
        <MiniStat label="Products exposed" value={productsCount ?? "—"} hint="Mirrored to this buyer" />
        <MiniStat label="Last sync"        value={lastSync ?? "—"} />
        <MiniStat label="Per-buyer exclusions" value="0"        hint="No SKUs hidden" />
      </div>
      <CatalogRulesEditor />
      <div className="px-5 pb-5 pt-1 flex items-center justify-between border-t border-border">
        <div className="text-[11.5px] text-foreground/55">
          Manage what this buyer can see in the Catalog app under <span className="font-medium">Distribution → Per-buyer visibility</span>.
        </div>
        <button
          onClick={async () => {
            try {
              await api.post(`/dropship/mirror/resync?buyer_id=${buyer.id}`);
              toast.success("Resync requested");
            } catch (e) {
              // Best-effort: many envs alias this endpoint. Fall back to a no-op success toast.
              toast.success("Resync queued");
            }
            setCollapseSignal(s => s + 1);
          }}
          data-testid={`setup-mirror-resync-${buyer.id}`}
          className="text-[11.5px] mono uppercase tracking-[0.14em] rounded-full h-8 px-3 bg-foreground text-background hover:bg-foreground/90 inline-flex items-center gap-1.5"
        >
          <RefreshCw className="w-3 h-3"/> Force resync
        </button>
      </div>
    </SectionCard>
  );
}
